<template>
  <span>
    <div class="w-full">
      <!-- Title -->
      <!-- TODO: Title and tooltip should be an independent component -->
      <label v-if="!hideTitle" class="text-text-color text-xs font-normal flex pb-1 h-16">
        {{ $t(`title.${title}`) }}
      </label>
      <!-- Main Container -->
      <div :class="selectBoxWidth">
        <input v-show="false" v-model="singleItem" />
        <section class="w-full relative">
          <UiOnClickOutside :do="onClickOutside">
            <div class="flex" :class="[selectedItemContainer]">
              <!-- Head of the dropdown -->
              <div v-if="showLock" style="padding-top: 2px" />
              <!-- SELECTED ITEMS ETC -->
              <div
                class="flex items-center rounded-lg cursor-pointer relative rtl:flex-row-reverse"
                :class="[
                  disabled && 'cursor-not-allowed',
                  inputColor,
                  inputBoxStyle,
                  borderStyle,
                  backgroundColor,
                  cardUnSelected ? 'border-transparent bg-primary-accent' : '',
                  cardSelected ? 'border-transparent bg-blackish-green' : '',
                  borderUpdate ? '' : 'border rounded-md',
                  borderRounded ? 'border rounded-full  ' : '',
                ]"
                @click.stop="toggleDropdown()"
                @click="toggleMode()"
              >
                <span
                  v-if="!singleItem"
                  v-i18n="landingPage"
                  class="text-sm opacity-50 overflow-hidden px-1.5"
                  :class="[getColor, placeholderClasses]"
                >
                  <!-- TODO: Select text should be dynamic -->
                  {{ $t(`placeholder.${placeholder}`) }}
                </span>
                <!-- header, if there is any selected item -->
                <span
                  v-else
                  class="overflow-hidden flex max-w-2 xl:max-w-2.5 w-auto h-full"
                  :class="[selectedItemClasses]"
                >
                  <div
                    class="flex w-full items-center my-auto"
                    :class="[languageStyling ? '' : 'rtl:pt-1 ltr:pt-0']"
                  >
                    <!-- TODO: Image for select should be independent compoenet so that it can be reused in chips, multi-select, single select -->
                    <div v-if="image">
                      <div v-if="image && singleItem.image !== null" class="w-7 h-7 mr-1">
                        <img :src="singleItem.image" class="h-full w-full rounded-full" />
                      </div>

                      <span
                        v-else
                        class="h-7 w-7 rounded-full cursor-pointer bg-gray-300 flex justify-center items-center text-sm text-white ltr:mr-1 rtl:ml-1"
                      >
                        {{ $t(`landingPage.${initials(getLabel(singleItem))}`) }}
                      </span>
                    </div>
                    <span
                      v-if="currentSelectedLanguage === 'ar'"
                      class="lg:text-base text-xs uppercase overflow-x-hidden overflow-ellipsis whitespace-nowrap inline-block w-full"
                      :class="[inputValueColor, customTextSize]"
                    >
                      <span v-if="customLabelClasses" class="flex flex-row-reverse gap-1">
                        <span :class="[customLabelClasses]">
                          {{ $t(`landingPage.${getLabel(singleItem).split(' ')[0] || ''}`) }}
                        </span>
                        <span>
                          {{ $t(`landingPage.${getLabel(singleItem).split(' ')[1] || ''}`) }}
                        </span>
                      </span>
                      <span v-else>
                        {{ $t(`landingPage.${getLabel(singleItem)}`) }}
                      </span>
                    </span>
                    <span
                      v-else
                      class="uppercase overflow-x-hidden overflow-ellipsis whitespace-nowrap inline-block w-full"
                      :class="[inputValueColor, customTextSize]"
                    >
                      <span v-if="customLabelClasses" class="flex gap-1">
                        <span :class="[customLabelClasses]">
                          {{ $t(`landingPage.${getLabel(singleItem).split(' ')[0] || ''}`) }}
                        </span>
                        <span>
                          {{ $t(`landingPage.${getLabel(singleItem).split(' ')[1] || ''}`) }}
                        </span>
                      </span>
                      <span v-else>
                        {{ $t(`landingPage.${getLangCodeFromLabel(getLabel(singleItem))}`) }}
                      </span>
                    </span>
                  </div>
                </span>
                <span>
                  <Icon
                    :icon="defaultIcon"
                    :height="iconHeight"
                    class="rtl:mr-2"
                    :class="disabled || !isVisible ? '' : 'rotate-180'"
                    :width="iconWidth"
                    :color="iconColor ? iconColor : bgColor"
                  />
                </span>
              </div>
              <!-- TODO: Dropdown should be a separate component -->
              <!-- Dropdown Section -->
              <div class="absolute z-40" :class="dropDownContainer">
                <div
                  v-if="isVisible && !disabled"
                  class="relative left-0 right-0 rounded-b-md bg-white py-2 px-1"
                  :class="[dropdownShadow]"
                >
                  <!-- TODO: Search should be an independent component so it can be used in both single and multi select or maybe somewhere else -->
                  <!-- search section -->

                  <div
                    class="items-center h-auto border-primary-grey border-b py-3"
                    :class="[hideSearchBar]"
                  >
                    <!-- <span class="absolute ltr:left-4 rtl:right-4">
                    <Iconpackage
                      class="icon xl:h-5 xl:w-5 h-4 w-4"
                      icon="search"
                      color="primary-grey-light"
                    />
                  </span> -->
                    <input
                      v-model="searchQuery"
                      class="h-10 ltr:pl-9 rtl:pr-9 bg-bg-color-light text-primary-grey-light rounded text-sm md:text-base focus:outline-none w-full"
                      type="text"
                      :placeholder="$t(`placeholder.Search`)"
                      @keyup="searchThroughApi ? emitQuery : filterData"
                    />
                  </div>

                  <!-- Selected List -->
                  <div v-if="singleItem" class="whitespace-nowrap">
                    <div
                      class="bg-primary-purple-50 rounded-lg flex justify-between items-center px-3 my-2"
                      :class="selectedDivHeight"
                    >
                      <div class="flex items-center truncate">
                        <div v-if="image">
                          <div v-if="image && singleItem.image !== null" class="w-7 h-7 mr-1">
                            <img :src="singleItem.image" class="h-full w-full rounded-full" />
                          </div>

                          <span
                            v-else
                            class="h-7 w-7 rounded-full cursor-pointer bg-gray-300 flex justify-center items-center text-sm text-gray-700 ltr:mr-1 rtl:ml-1"
                          >
                            {{ $t(`landingPage.${initials(getLabel(singleItem))}`) }}
                          </span>
                        </div>
                        <div class="font-regular capitalize text-text-color" :class="itemSize">
                          {{ $t(`landingPage.${getLabel(singleItem)}`) }}
                        </div>
                      </div>
                      <div v-if="!hideUnSelectIcon" @click="removeSelectedItem(singleItem)">
                        <Icon
                          class="cursor-pointer ml-4"
                          color="primary-green"
                          icon="cross-circle"
                          height="18"
                          width="18"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- Unselected List -->

                  <div class="pt-1 border-t border-primary-grey w-full">
                    <div
                      v-if="optionsArray.length === 0"
                      class="empty-list text-color-primary-grey text-center w-full p-2 bg-primary-white text-xs overflow-hidden"
                    >
                      {{ $t(`landingPage.${'dashboard.NO_ITEM'}`) }}
                    </div>

                    <div v-else class="options w-full mt-1">
                      <ul>
                        <li
                          v-for="(item, index) in filterData"
                          :key="index"
                          class="w-full cursor-pointer h-10 flex items-center hover:bg-bg-color-light"
                          @click="selectSingletItem(item)"
                        >
                          <div class="flex items-center px-2 truncate">
                            <!-- TODO: image should be independent component -->
                            <div v-if="image">
                              <div v-if="image && item.image !== null" class="w-7 h-7">
                                <img :src="item.image" class="h-full w-full rounded-full" />
                              </div>

                              <span v-else>
                                <div
                                  class="h-7 w-7 p-0.5 rounded-full cursor-pointer bg-white flex justify-center items-center text-xs text-gray-700 mr-1 rtl:ml-2"
                                >
                                  {{ $t(`landingPage.${initials(getLabel(item))}`) }}
                                </div>
                              </span>
                            </div>
                            <div
                              class="truncate capitalize font-regular w-full text-text-color"
                              :class="image ? '' : 'ml-1'"
                            >
                              {{ $t(`landingPage.${getLabel(item)}`) }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </UiOnClickOutside>
        </section>
      </div>
    </div>
  </span>
</template>

<script>
import Icon from '@src/components/icons/icon.vue'
import { filterdData } from '@src/utils/generalUtil.js'
import UiOnClickOutside from '@/src/components/misc/UiOnClickOutside.vue'
import generalMixin from '@src/mixins/general-mixins.js'
import { mapState } from 'vuex'
export default {
  name: 'UiSelectBox',
  components: {
    Icon,
    UiOnClickOutside,
  },
  mixins: [generalMixin],

  props: {
    placeholder: {
      type: String,
      default: 'Select',
    },
    socialMedia: {
      type: String,
      default: '',
    },
    borderUpdate: {
      type: Boolean,
      default: false,
    },
    borderRounded: {
      type: Boolean,
      default: false,
    },
    borderRemove: {
      type: Boolean,
      default: false,
    },
    inputColor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    cardUnSelected: {
      type: Boolean,
      default: false,
    },
    customLabelClasses: {
      type: String,
      default: '',
    },
    component: {
      type: String,
      default: '',
    },

    modelValue: {
      type: [String, Number, Boolean, Object],
      default: '',
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },

    hideUnSelectIcon: {
      type: Boolean,
      default: false,
    },
    dropDownContainer: {
      type: String,
      default: 'w-full top-11',
    },
    rules: {
      type: String,
      default: '',
    },
    customTextSize: {
      type: String,
      default: 'lg:text-base text-xs',
    },

    backgroundColor: {
      type: String,
      default: '',
    },
    image: {
      type: Boolean,
      default: false,
    },

    options: {
      type: [Array, Object],
      default: () => [],
    },
    languageStyling: {
      type: String,
      default: 'text-text-color',
    },
    defaultIcon: {
      type: String,
      default: 'chevron-bottom',
    },
    iconColor: {
      type: String,
      default: '',
    },
    iconWidth: {
      type: Number,
      default: 15,
    },
    iconHeight: {
      type: Number,
      default: 15,
    },
    placeholderClasses: {
      type: String,
      default: '',
    },
    selectedItemContainer: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'title',
    },
    label: {
      type: String,
      default: 'title',
    },
    reduce: {
      type: String,
      default: '',
    },
    selectedItemClasses: {
      type: String,
      default: 'title',
    },
    showLock: {
      type: Boolean,
      default: false,
    },
    searchThroughApi: {
      type: Boolean,
      default: false,
    },
    itemSize: {
      type: String,
      default: 'text-base',
    },
  },

  data() {
    return {
      searchQuery: '',
      singleItem: '',
      optionsArray: [],
      isVisible: false,
      itemIndex: '',
      dashboard: 'dashboard',
      landingPage: 'landingPage',
    }
  },
  computed: {
    ...mapState(['currentSelectedLanguage']),
    selectBoxWidth() {
      let width = this.borderUpdate
        ? this.languageStyling
          ? ''
          : 'min-w-1'
        : 'min-w-1 md:min-w-1.5'
      return width
    },

    borderStyle() {
      let response = this.borderUpdate ? 'gap-2 w-full justify-between' : 'justify-between '
      return response
    },
    inputBoxStyle() {
      let response = this.columnTextSize
        ? 'md:h-7.5 column-selectbox-width h-7'
        : this.socialMedia
        ? this.socialMedia
        : 'input-height h-full w-full'
      return response
    },
    /**
     * Filter Data
     * @returns {String} - filtered String
     * @description filter data from options list by input search query returning the filtered list.
     */
    filterData() {
      const query = this.searchQuery.toLowerCase()
      if (this.searchThroughApi) return this.optionsArray
      else return filterdData(query, this.optionsArray)
    },
    emitQuery() {
      const query = this.searchQuery.toLowerCase()
      return this.$emit('search', query)
    },
    hideSearchBar() {
      let response
      if (this.optionsArray.length <= 9 && !this.searchThroughApi) {
        response = 'hidden'
      } else {
        response = 'flex'
      }

      return response
    },
    getColor() {
      let clr = this.cardSelected
        ? 'text-white '
        : this.cardUnSelected
        ? 'text-primary-green'
        : 'text-color-primary-grey'
      return clr
    },
    bgColor() {
      let clr = this.cardUnSelected
        ? 'bg-blackish-green'
        : this.cardSelected || this.languageStyling === 'text-white'
        ? 'bg-white'
        : 'black'
      return clr
    },
    inputValueColor() {
      let clr = this.cardSelected
        ? 'text-white '
        : this.cardUnSelected
        ? 'text-primary-green'
        : this.languageStyling
      return clr
    },
    selectedDivHeight() {
      let height = this.languageStyling ? 'h-8' : 'h-10'
      return height
    },
    dropdownShadow() {
      let shadow = this.languageStyling ? 'sm:shadow-2xl shadow-lg' : 'shadow-2xl'
      return shadow
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.optionsArray = JSON.parse(JSON.stringify(this.options))
        if (this.modelValue) this.editForm()
      },
    },
    modelValue: {
      handler(value) {
        if (value) this.editForm()
      },
    },
  },

  methods: {
    toggleMode() {
      this.$emit('changeMode')
    },
    /**
     * Remove Selected Item
     * @param {object} item
     * @returns {void}
     * @description Function description:
     * - Gets item as param and remove it from selected items list
     * - Adds item in unselected items
     * - Emitting the removed item
     */
    removeSelectedItem(item) {
      this.optionsArray.splice(this.itemIndex, 0, item)
      this.singleItem = ''
      this.$emit('receiveList', this.singleItem)
      this.$emit('deSelect', item)
    },
    /**
     * Edit Form
     * @description getting the data through v-model if any edit form is opened,
     */
    editForm() {
      // if options passed are objects
      if (this.reduce)
        this.optionsArray.filter((option, idx) => {
          if (option[this.reduce] === this.modelValue) {
            this.optionsArray.splice(idx, 1)
            this.itemIndex = idx
            this.singleItem = option
          }
        })
      // if options are static array (not objects)
      else {
        this.singleItem = this.modelValue
        this.optionsArray.filter((option, idx) => {
          if (JSON.stringify(option) === JSON.stringify(this.singleItem)) {
            this.optionsArray.splice(idx, 1)
            this.itemIndex = idx
          }
        })
      }
    },
    /**
     * Get Label
     * @param {object | *}  - option
     * @returns {object} - option
     * @description Function Description :
     * - checking the type of param, if it is object then returning the filtered data from the list
     */
    getLabel(option) {
      if (typeof option === 'object') {
        return option[this.label]
      }
      return option
    },
    getLangCodeFromLabel(label) {
      const map = {
        English: 'EN',
        Urdu: 'Ur',
        Arabic: 'Ar',
      }
      return map[label] || label
    },
    /**
     * Toggle Dropdown
     * @description Open or Close the dropdown
     */
    toggleDropdown() {
      this.isVisible = !this.isVisible
      if (!this.isVisible && this.searchThroughApi) {
        this.searchQuery = ''
        this.$emit('search', this.searchQuery)
      }
    },
    /**
     * On Click Outside
     * @description Close the dropdown and reset the search box
     */
    onClickOutside() {
      this.searchQuery = ''
      if (this.isVisible && this.searchThroughApi) this.$emit('search', this.searchQuery)
      this.isVisible = false
    },
    /**
     * Select Single Item
     * @param {object }  - item
     * @returns {Void}
     * @description Function Description :
     * - Get single item as param and assign it to a data variable
     * - If reducer is passed, we are emitting the reduced value of the item otherwise the complete item
     * - Closing the dropdown if any value is selected
     */
    selectSingletItem(item) {
      let value
      if (this.singleItem) {
        this.optionsArray.splice(this.itemIndex, 0, this.singleItem)
      }
      this.singleItem = item
      if (this.reduce)
        this.optionsArray.filter((option, idx) => {
          if (option[this.reduce] === this.singleItem[this.reduce]) {
            this.optionsArray.splice(idx, 1)
            this.itemIndex = idx
          }
        })
      else
        this.optionsArray.filter((option, idx) => {
          if (option === this.singleItem) {
            this.optionsArray.splice(idx, 1)
            this.itemIndex = idx
          }
        })

      if (this.reduce) value = this.singleItem[this.reduce]
      else value = this.singleItem
      if (this.reduce) {
        this.$emit('selectedObj', this.singleItem)
      }
      this.$emit('receiveList', value)
      this.$emit('update:modelValue', value)
      this.$emit('change', value)

      this.searchQuery = ''
      if (this.searchThroughApi) this.$emit('search', this.searchQuery)
      this.isVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rotate-180 {
  rotate: 180deg;
}

ul {
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: start;
  list-style: none;
}

.input-height {
  min-height: 33px;
}

.badge .tooltip-text {
  &::before {
    position: absolute;
    top: -7px;
    width: 13px;
    height: 13px;
    content: '';
    background: var(--bg-white);
    border-top: 1px solid var(--text-color-info);
    border-left: 1px solid var(--text-color-info);
    transform: rotate(45deg);
  }
  & {
    position: absolute;
    top: 35px;
    left: -8px;
    z-index: 1;
    min-height: 40px;
    padding: 5px;
    margin-left: 5px;
    overflow-y: hidden;
    color: rgb(12, 12, 12);
    text-align: left;
    background-color: rgb(255, 255, 255);
    border-radius: 6px;
    box-shadow: 0 0 3px 0.1px;
    transition: opacity 0.3s;
  }
}

.error-msg {
  font-size: 12px;
  font-style: italic;
  color: var(--text-color-danger);
}

.column-selectbox-width {
  width: 107px;
}

@media (min-width: 769px) {
  .column-selectbox-width {
    width: 115px;
  }
}
</style>

<style lang="scss">
.vs__selected-options {
  flex-wrap: inherit;
  padding: 0;
  font-size: 0.875rem;
}

.vs__actions {
  padding: 0;
  cursor: pointer;
}

.error-msg {
  font-size: 12px;
  font-style: italic;
  color: var(--text-color-danger);
}

.v-select.error-border div.vs__dropdown-toggle {
  background-color: var(--bg-error);
  border: 1px solid var(--text-color-danger) !important;
}

.input-field {
  .vs__dropdown-toggle {
    position: relative;
    min-width: 90px;
    height: 100%;
    padding: 9px 15px 9px 15px;
    overflow: auto;
    color: var(--primary-grey-light);
    letter-spacing: 0;
    white-space: nowrap;
    background-color: var(--primary-white);
    border: none;
    border-radius: 7px;
  }

  div[aria-expanded='true'].vs__dropdown-toggle {
    border-bottom-right-radius: 7px !important;
    border-bottom-left-radius: 7px !important;
  }

  .vs__dropdown-menu {
    top: auto;
    z-index: 2000;
    min-width: 115px;
    background-color: var(--primary-white);
    border: 0.5px solid var(--primary-grey);
    border-top-width: 1px;
    border-bottom-right-radius: 7px;
    border-bottom-left-radius: 7px;

    li {
      padding-left: 9px;
      font-size: 0.875em;
      color: var(--label-text);
      text-transform: capitalize;
      cursor: pointer;
      user-select: none;
      background-color: var(--primary-white);

      &:hover {
        background-color: var(--bg-light);
      }
    }
  }

  .vs__selected-options {
    .vs__selected {
      align-content: center;
      align-items: center;
      padding: 0;
      margin: 0;
      color: var(--label-text);
      background-color: transparent;
    }

    .vs__search {
      background-color: transparent;
    }

    .vs__search:focus {
      flex: none;
      padding: 0;
      margin: 0;
    }
  }

  .vs__clear {
    visibility: hidden;
  }

  .vs__open-indicator {
    background-color: transparent;
    fill: var(--primary-grey);
  }

  .vs__deselect {
    fill: var(--label-text);
  }
}

.vs--disabled {
  .vs__dropdown-toggle {
    background-color: var(--primary-white);
  }
}
</style>
